import { EnvironmentId } from "@afar-research/contracts";
import { useLocation } from "@tanstack/react-router";
import { DraftId, useComposerDraftStore } from "../composerDraftStore";

const decodePathPart = (part: string | undefined) => {
  if (!part) return null;
  try {
    return decodeURIComponent(part);
  } catch {
    return null;
  }
};

/** The Environment selected by either a native thread route or a draft thread route. */
export function useRouteEnvironmentId(): string | null {
  const pathname = useLocation({ select: (location) => location.pathname });
  const [, first, second] = pathname.split("/");
  const routeId = decodePathPart(second);
  const draftEnvironmentId = useComposerDraftStore((store) =>
    first === "draft" && routeId
      ? (store.getDraftSession(DraftId.make(routeId))?.environmentId ?? null)
      : null,
  );
  if (first === "draft") return draftEnvironmentId;
  const environmentId = decodePathPart(first);
  if (!environmentId || !routeId) return null;
  return EnvironmentId.make(environmentId);
}
